var map = {
	"./add.svg": "58n+",
	"./agent.svg": "Liw6",
	"./analysis.svg": "/tUJ",
	"./banner.svg": "DXJQ",
	"./exam.svg": "IQTm",
	"./home.svg": "U9Ws",
	"./learn.svg": "Z/vv",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./read.svg": "7/AS",
	"./role.svg": "cqqK",
	"./sale.svg": "LguS",
	"./setting.svg": "Kttn",
	"./tree.svg": "3eCm",
	"./type.svg": "Kg5v",
	"./ums-admin.svg": "FR/6",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./users.svg": "5tDr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 19